import { View } from "react-native-web";
import { CImage } from "../../../components/atoms";
import { Constants, Images } from "../../../config";

export const rooftopFilterCriteria = (isMobileVersion, styles) => {
  return [
    {
      title: "Location",
      isHide: isMobileVersion,
      isLocation: true,
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_VENUE,
      icon: Images.iconTagGeneral,
      width: 20,
      height: 20,
      title: "Venue",
      isHide: false,
      detailList: [
        {
          id: 7,
          label: "Indoor & Outdoor",
          tagId: 801,
        },
        {
          id: 8,
          label: "Indoor Only",
          tagId: 802,
        },
        {
          id: 9,
          label: "Outdoor Only",
          tagId: 803,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_SERVICE,
      icon: Images.iconTagService,
      width: 20,
      height: 20,
      title: "Service",
      isHide: false,
      detailList: [
        {
          id: 2,
          label: "Bar",
          tagId: 1602,
        },
        {
          id: 3,
          label: "Restaurant",
          tagId: 1603,
        },
        {
          id: 1,
          label: "Club",
          tagId: 1601,
        },
        {
          id: 4,
          label: "Wellness",
          tagId: 1604,
        },
        {
          id: 5,
          label: "Other",
          tagId: 1605,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_ROOFTOP_FEATURES,
      icon: Images.iconTagLightning,
      width: 20,
      height: 20,
      title: "Features",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Pool",
          tagId: 2501,
        },
        {
          id: 2,
          label: "Wellness",
          tagId: 2502,
        },
        {
          id: 3,
          label: "Upscale",
          tagId: 2503,
        },
        {
          id: 4,
          label: "Elegant",
          tagId: 2504,
        },
        {
          id: 5,
          label: "Underground",
          tagId: 2505,
        },
        {
          id: 6,
          label: "Casual",
          tagId: 2506,
        },
        {
          id: 7,
          label: "Live music",
          tagId: 2507,
        },
        {
          id: 8,
          label: "Members",
          tagId: 2508,
        },
        {
          id: 9,
          label: "Live Show",
          tagId: 2509,
        },
        {
          id: 10,
          label: "Cinema",
          tagId: 2510,
        },
        {
          id: 11,
          label: "N/A",
          tagId: 2511,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_VIEW,
      icon: Images.iconTagView,
      width: 20,
      height: 20,
      title: "View",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "90°",
          tagId: 2201,
        },
        {
          id: 2,
          label: "180°",
          tagId: 2202,
        },
        {
          id: 3,
          label: "270°",
          tagId: 2203,
        },
        {
          id: 4,
          label: "360°",
          tagId: 2204,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_PRICE_VENUE,
      icon: Images.iconTagPrice,
      width: 20,
      height: 20,
      title: "Price",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "1",
          tagId: 1501,
          prefixIcon: (
            <View style={styles.row}>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPriceGray}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPriceGray}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 0 : 3 }}>
                <CImage
                  source={Images.iconTagPriceGray}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
            </View>
          ),
        },
        {
          id: 2,
          label: "2",
          tagId: 1502,
          prefixIcon: (
            <View style={styles.row}>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPriceGray}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 0 : 3 }}>
                <CImage
                  source={Images.iconTagPriceGray}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
            </View>
          ),
        },
        {
          id: 3,
          label: "3",
          tagId: 1503,
          prefixIcon: (
            <View style={styles.row}>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 0 : 3 }}>
                <CImage
                  source={Images.iconTagPriceGray}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
            </View>
          ),
        },
        {
          id: 4,
          label: "4",
          tagId: 1504,
          prefixIcon: (
            <View style={styles.row}>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 0 : 3 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
            </View>
          ),
        },
        {
          id: 5,
          label: "N/A",
          tagId: 1505,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_ROOFTOP_SIZE,
      icon: Images.iconTagSize,
      width: 20,
      height: 20,
      title: "Size",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "XS",
          suffix: "0-20",
          tagId: 2401,
        },
        {
          id: 2,
          label: "S",
          suffix: "21-50",
          tagId: 2402,
        },
        {
          id: 3,
          label: "M",
          suffix: "51-100",
          tagId: 2403,
        },
        {
          id: 4,
          label: "L",
          suffix: "101-200",
          tagId: 2404,
        },
        {
          id: 5,
          label: "XL",
          suffix: "201-500",
          tagId: 2405,
        },
        {
          id: 6,
          label: "XXL",
          suffix: "500+",
          tagId: 2406,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_DRESS_CODE,
      icon: Images.iconTagDressCode,
      width: 20,
      height: 20,
      title: "Dress Code",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Casual",
          tagId: 1001,
        },
        {
          id: 2,
          label: "Smart",
          tagId: 1002,
        },
        {
          id: 3,
          label: "Elegant",
          tagId: 1003,
        },
        {
          id: 4,
          label: "N/A",
          tagId: 1004,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_STATUS,
      icon: Images.iconTagStatus,
      width: 20,
      height: 20,
      title: "Status",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Open",
          tagId: 1,
        },
        {
          id: 2,
          label: "Closed",
          tagId: 2,
        },
        {
          id: 3,
          label: "Temporarily Closed",
          tagId: 4,
        },
        {
          id: 4,
          label: "Permanently Closed",
          tagId: 3,
        },
      ],
      selectedList: [1, 2, 4],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_AREA,
      icon: Images.iconTagArea,
      width: 20,
      height: 20,
      title: "Area",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "City",
          tagId: 901,
        },
        {
          id: 2,
          label: "Town",
          tagId: 902,
        },
        {
          id: 3,
          label: "Countryside",
          tagId: 903,
        },
        {
          id: 4,
          label: "Field",
          tagId: 904,
        },
        {
          id: 5,
          label: "Forest",
          tagId: 905,
        },
        {
          id: 6,
          label: "Lake",
          tagId: 906,
        },
        {
          id: 7,
          label: "Beach",
          tagId: 907,
        },
        {
          id: 8,
          label: "Mountain",
          tagId: 908,
        },
        {
          id: 9,
          label: "Park",
          tagId: 909,
        },
        {
          id: 10,
          label: "Resort",
          tagId: 910,
        },
        {
          id: 11,
          label: "Unique Location",
          tagId: 911,
        },
        {
          id: 12,
          label: "Ship",
          tagId: 912,
        },
        {
          id: 13,
          label: "Other",
          tagId: 913,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_RATING,
      icon: Images.iconTagRating,
      width: 21.5,
      height: isMobileVersion ? 21 : 20,
      title: "Rating",
      isHide: true,
      isRating: true,
      detailList: [
        {
          id: 1,
          label: "1",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating1}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 2,
          label: "2",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating2}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 3,
          label: "3",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating3}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 4,
          label: "4",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating4}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 5,
          label: "5",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating5}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
      ],
      selectedList: [],
    },
  ];
};
